import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-badge',
  imports: [],
  templateUrl: './badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  public label = input.required<string>();
  public cssClass = input<string>('');
}
